import * as R from 'ramda'
import * as React from 'react'
import * as ReactRedux from 'react-redux'
import PropTypes from 'prop-types'

import * as Common from '@rushplay/common'
import * as Icons from '@rushplay/icons'
import * as I18n from '@rushplay/i18n'
import css from '@styled-system/css'
import styled from '@emotion/styled'

import * as CombinedSelectors from '../combined-selectors'
import * as Utils from '../utils'

const Background = styled.div`
  position: relative;
  display: flex;
  background-image: ${props => `url(${props.image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  min-width: 100vw;
  width: 100%;
  &:after {
    content: '';
    mask: url(/images/wave-tile.svg);
    display: block;
    width: 100%;
    align-self: flex-end;
    height: 10px;
    ${css({
      backgroundColor: 'background',
    })}
  }
`

const Slider = styled.div`
  scroll-snap-type: x mandatory;
  display: flex;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;

  ::-webkit-scrollbar {
    display: none;
  }

  ${css({
    height: '40vh',
    marginBottom: [null, 0, 1],
    marginRight: [null, '-24px', '-16px'],
    marginLeft: [null, '-24px', '-16px'],
    marginTop: [null, '-32px', '-24px'],
  })}
`
export function LobbyBanner(props) {
  const i18n = I18n.useI18n()
  const isMobile = ReactRedux.useSelector(state =>
    CombinedSelectors.getIsMobile(state)
  )
  const promotionsCount = props.promotions.length
  const slider = Utils.Hooks.useSlider(promotionsCount)

  return (
    <React.Fragment>
      <Slider ref={slider.ref}>
        {R.map(
          promotion => (
            <Background
              key={promotion.key}
              image={
                isMobile
                  ? i18n.translate(
                      `promotions.${R.path(['key'], promotion)}.img-src.mobile`
                    )
                  : i18n.translate(
                      `promotions.${R.path(['key'], promotion)}.img-src`
                    )
              }
            >
              <Common.Link to={R.path(['loggedInButtonLink'], promotion)}>
                <Common.Box
                  as="img"
                  alt="Overlay"
                  src={i18n.translate(
                    `promotions.${R.path(['key'], promotion)}.img-src.overlay`
                  )}
                  top="0px"
                  bottom="0px"
                  left="0px"
                  right="0px"
                  margin="auto"
                  position="absolute"
                  height={[null, '85%', null]}
                  maxHeight="35vh"
                  maxWidth="90%"
                />
              </Common.Link>
            </Background>
          ),
          props.promotions
        )}
      </Slider>
      {promotionsCount > 1 && !isMobile && (
        <React.Fragment>
          <SliderNavigationButton
            position="left"
            onClick={() => slider.handleScrollBy(-window.innerWidth, 0)}
          />
          <SliderNavigationButton
            position="right"
            onClick={() => slider.handleScrollBy(window.innerWidth, 0)}
          />
        </React.Fragment>
      )}

      {promotionsCount > 1 && (
        <Common.Box textAlign="center" marginTop={1}>
          {props.promotions.map((promotion, index) => (
            <Common.Box
              key={promotion.key}
              cursor="pointer"
              marginRight="0"
              height="15px"
              width="15px"
              border={
                index === slider.activeSlide - 1 ? '2px solid darkblue' : 'none'
              }
              backgroundColor="gray1"
              borderRadius="50%"
              display="inline-block"
              onClick={() => slider.handleScrollTo(window.innerWidth * index)}
            />
          ))}
        </Common.Box>
      )}
    </React.Fragment>
  )
}

LobbyBanner.propTypes = {
  promotions: PropTypes.array,
}

function SliderNavigationButton(props) {
  return (
    <Common.Box
      cursor="pointer"
      position="absolute"
      top="40vh"
      left={props.position === 'left' ? '5%' : undefined}
      right={props.position === 'right' ? '5%' : undefined}
      p="1"
      color="darkblue"
      onClick={props.onClick}
    >
      <Icons.IconWrapper size="30px">
        {props.position === 'left' ? (
          <Icons.IconChevronLeft />
        ) : (
          <Icons.IconChevronRight />
        )}
      </Icons.IconWrapper>
    </Common.Box>
  )
}

SliderNavigationButton.propTypes = {
  children: PropTypes.node,
  position: PropTypes.string,
  onClick: PropTypes.func,
}
